import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Parallax from 'parallax-js';
import classes from '@nerdwallet/base-styles/classes';
import { Type } from '@nerdwallet/currency';
import NoResultsLeft from '~/client/components/svg/no-results-left';
import NoResultsRight from '~/client/components/svg/no-results-right';

class NoResults extends Component {
  static onParallaxRef(ref) {
    if (!ref) return;
    // eslint-disable-next-line no-new
    new Parallax(ref);
  }

  render() {
    const { query, useQuery, error } = this.props;

    return (
      <div className="no-results">
        <div className="no-results-text">
          {!error && (
            <Type
              size={3}
              className={classes(
                'text-align-center--wide',
                'color-white',
                'margin-bottom-2'
              )}
            >
              {' '}
              Sorry! We looked everywhere, but could not find:{' '}
            </Type>
          )}
          {error && (
            <Type
              size={3}
              className={classes(
                'text-align-center--wide',
                'color-white',
                'margin-bottom-2'
              )}
            >
              {' '}
              Oh my stars! Something doesn&apos;t look right. Please try that
              search term again and we’ll see if we can get things into focus.{' '}
            </Type>
          )}
          {useQuery && (
            <Type
              size={3}
              bold
              className={classes(
                'text-align-center--wide',
                'color-white',
                'margin-bottom-2'
              )}
            >
              <span className={classes('nowrap')}>
                &#x201C;&#x202F;
                {query}
                &#x202F;&#x201D;
              </span>{' '}
            </Type>
          )}{' '}
          {!error && (
            <Type
              size={2}
              className={classes('text-align-center--wide', 'color-white')}
            >
              {' '}
              To get pointed in the right direction, double check your spelling
              or try using a more general search term.{' '}
            </Type>
          )}
        </div>
        <div className="background">
          <div className="parallax-container" ref={NoResults.onParallaxRef}>
            <NoResultsLeft data-depth="0.2" className="no-results-left" />
          </div>
          <NoResultsRight className="no-results-right" />
        </div>
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
NoResults.propTypes = {
  query: PropTypes.string,
  useQuery: PropTypes.bool,
  error: PropTypes.bool,
};

export default NoResults;
